/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PaymentTypeEnum {
    CC = 'CC',
    ACH = 'ACH',
    OTHER = 'Other',
    CASH = 'Cash',
    CHECK = 'Check',
    MONEY_ORDER = 'MoneyOrder',
}